import { DeclaracionPj } from '../../../../../models/trust/proveedorPj/DeclaracionPj';
import * as generic from '../../../../../components/Generico';
import { ProveedorPjService } from "../../../../../service/trust/ProveedorPjService";
import { InputComponent } from '../../../../../components/InputComponent';
import { useEffect, useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Panel } from 'primereact/panel';
import { useForm } from 'react-hook-form';
import { Divider } from 'primereact/divider';
import { useSubmitForm } from '../../../../../hooks/useSubmitForm';
import { BottomActionBar } from '../../../../../components/ui/BottomActionBar';

export const Declaracion = ({ toast, id, permss, proveedor, handlePrev, nuevoProveedor, siCliente, urls, setDialogProveedor, setDialogAnexos, loadLazyData, reiniciar, soloLectura }) => {

    const omodel = new DeclaracionPj();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues, shouldTrim: true });
    const proveedorServicio = new ProveedorPjService();
    const { inText, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = useSubmitForm({ toast, setError });
    const [isLoading, setIsLoading] = useState(true);
    const [load, setLoad] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [esPep, setEsPep] = useState(false);
    const [esRelacionPep, setEsRelacionPep] = useState(false);
    const [anexosRequisitos, setAnexosRequisitos] = useState([]);

    useEffect(() => {
        if (id) {
            editFicha();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        proveedorServicio.consultarProveedor(id, { seccion: 'seccion4' }).then(res => {
            if (res.data.anexos_requisitos !== undefined) {
                setAnexosRequisitos(res.data.anexos_requisitos);
            }

            const _prov = res.data.proveedor;
            if (!_prov) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            setEsPep(_prov.pep?.cat_id === true || _prov.pep === true);
            setEsRelacionPep(_prov.relacion_pep?.cat_id === true || _prov.relacion_pep === true);

            reset(generic.renewValues(_prov, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setLoad(true);
        data.seccion = 'seccion4';
        data.id = id;

        proveedorServicio.editarProveedor(data).then(res => {
            if (nuevoProveedor) nuevoProveedor(res.data);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoad(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Revise los campos requeridos antes de guardar.', life: 3000 });
    }

    const onChangePep = (e) => {
        const isPep = e.value?.cat_id === true;
        setEsPep(isPep);
        if (!isPep) {
            setValue('cargo_pep', '');
            setValue('tiempo_pep', '');
        }
    }

    const onChangeRelacionPep = (e) => {
        const isRelacion = e.value?.cat_id === true;
        setEsRelacionPep(isRelacion);
        if (!isRelacion) {
            setValue('nombre_pep', '');
            setValue('cargo_nombre_pep', '');
            setValue('tiempo_nombre_pep', '');
            setValue('tipo_relacion_pep', '');
        }
    }

    const generarReporte = () => {
        setLoadReport(true);
        proveedorServicio.descargar(id).then(res => {
            generic.downloadPdf(res, `${id}-Formulario-Informacion-Proveedor-PJ.pdf`);
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => { if (setDialogAnexos) setDialogAnexos(true); }

    const enviar = () => {
        enviarFormulario(id, 'ficha/trust/proveedor-pj/enviar', 'proveedorPj');
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit, onError)}>
                <Panel header={generic.renderPanelHeader('G', 'DECLARACIÓN SOBRE LA CONDICIÓN DE PERSONA EXPUESTA POLÍTICAMENTE (REPRESENTANTE LEGAL)', 'pi pi-id-card')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid p-2">
                        {inDrop('pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangePep, val: true }, 12)}
                        {esPep && inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                        {esPep && inText('tiempo_pep', { icon: 'pi pi-clock' }, 6)}
                    </div>
                    <Divider />
                    <div className="formgrid grid p-2">
                        {inDrop('relacion_pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangeRelacionPep, val: true }, 12)}
                        {esRelacionPep && inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                        {esRelacionPep && inText('cargo_nombre_pep', { icon: 'pi pi-briefcase' }, 6)}
                        {esRelacionPep && inText('tiempo_nombre_pep', { icon: 'pi pi-clock' }, 6)}
                        {esRelacionPep && inText('tipo_relacion_pep', { icon: 'pi pi-link' }, 6)}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('H', 'AUTORIZACIÓN DE ACCESO DE INFORMACIÓN', 'pi pi-info-circle')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Términos de Autorización</span>
                        </div>
                        {omodel.msgAcceso}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('I', 'DECLARACIÓN', 'pi pi-file-edit')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-check-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Certificación de Veracidad y Reporte Fiscal</span>
                        </div>
                        {omodel.msgDeclaracion}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-shield text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                        </div>
                        {omodel.strAutorizacionTratamientoDatos}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('', 'Anexos Requeridos', 'pi pi-paperclip')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-file text-yellow-600 text-lg"></i>
                            <span className="font-bold text-yellow-900">Documentos requeridos</span>
                        </div>
                        <ul className="pl-4 m-0">
                            {anexosRequisitos.map((req, index) => (
                                <li key={index} className="mb-1">{req}</li>
                            ))}
                        </ul>
                    </div>
                </Panel>

                <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onSave={true} onGenerate={() => generarReporte()} onSend={enviar}
                    onAttachments={subirReporte} loading={load || loadReport} isReadOnly={soloLectura} enableExtras={id != null} />
            </form>
        </>
    );
}